import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
    visibleProjects: [],
};

export const projectSlice = createSlice({
    name: 'projects',
    initialState,
    reducers: {
        setProjects: (state, action) => {
            state.visibleProjects = action.payload;
        },
    },
});

export const { setProjects } = projectSlice.actions;

export default projectSlice.reducer;
